import React, { ComponentProps } from 'react';

import { Tabs } from '@zapier/design-system';

type Props = {
  currentUrl?: string;
  items: ComponentProps<typeof Tabs>['items'];
};

/*
 * This is a hacky resolution wrapping the Tabs component of
 * @zapier/design-system to meet our requirements. We want each tab to be a rich
 * link which trigges client-side routing while clicking.
 */
function LinkTabs(props: Props) {
  const { currentUrl, items } = props;

  // Sort by href length descending to match most specific URLs first.
  // This handles cases like /issues and /issues/zapier-issue-manager where
  // the shorter URL is a prefix of the longer one.
  const matchingItems = items
    .filter(item => item.href && currentUrl?.startsWith(item.href))
    .sort((a, b) => b.href.length - a.href.length);
  const itemSelected = matchingItems[0];
  const selectedItemHref = itemSelected?.href ?? '';

  return (
    <Tabs
      items={items}
      onChooseItem={(_item, event) => event.preventDefault()}
      selectedItemHref={selectedItemHref}
    />
  );
}

export default LinkTabs;
